













import {Vue, Component, Prop, Emit, Watch} from "vue-property-decorator";
import ClickOutside from "vue-click-outside";
import {v4 as uuid_v4} from "uuid";
@Component({directives: {
    ClickOutside,
  },})
export default class TreePropInput extends Vue {
  @Prop() value!: string;
  @Prop() editable!: boolean;

  private modelData: string = this.value;

  @Watch('modelData')
  watchModelData(newValue: string){
    this.emitInput(newValue);
  }

  @Emit('input')
  emitInput(value: string) { return value.replace(' ', ''); }

  clickOutsite(){
      this.activatedPropNameEdit(false);
  }

  @Emit('activated-edit')
  activatedPropNameEdit(newValue: boolean){
    return newValue;
  }

  get genUID(){
    return uuid_v4();
  }

}
